import { ReactElement } from 'react';
import Head from 'next/head';

import { Footer } from 'components/organisms/footer';
import { headerLinks } from 'lib/constants/header';
import FreePlatform, {
  FreePlatformProps,
} from 'components/organisms/candidates/freePlatform';
import GeekComments, {
  GeekCommentsProps,
} from 'components/organisms/candidates/geekComments';
import LandingPageHeader from 'components/organisms/landingPageHeader';
import RegistrationForm, {
  RegistrationFormProps,
} from 'components/organisms/candidates/registrationForm';
import RegistrationSteps, {
  RegistrationStepsProps,
} from 'components/organisms/candidates/registrationSteps';

export interface CreateFreeProfileProps
  extends RegistrationFormProps,
    RegistrationStepsProps,
    GeekCommentsProps,
    FreePlatformProps {}

const CreateFreeProfile = ({
  formTitle,
  formList,
  formStep,
  changeFormStep,
  submitFirstStep,
  submitSecondStep,
  formErrors,
  formRef,
  registrationStepsTitle,
  registrationSteps,
  companiesTitle,
  companiesLogo,
  geekiesTitle,
  geekiesComments,
  geekCommentsButton,
  geekCommentsButtonIcon,
  freePlatformBadge,
  freePlatformTitle,
  freePlatformButton,
  freePlatformButtonIcon,
}: CreateFreeProfileProps): ReactElement => (
  <>
    <Head>
      <title>GeekHunter: Criar Perfil Grátis</title>
    </Head>

    <LandingPageHeader headerLinks={headerLinks} />

    <RegistrationForm
      formTitle={formTitle}
      formList={formList}
      formStep={formStep}
      changeFormStep={changeFormStep}
      submitFirstStep={submitFirstStep}
      submitSecondStep={submitSecondStep}
      formErrors={formErrors}
      formRef={formRef}
    />

    <RegistrationSteps
      registrationStepsTitle={registrationStepsTitle}
      registrationSteps={registrationSteps}
    />

    <GeekComments
      companiesTitle={companiesTitle}
      companiesLogo={companiesLogo}
      geekiesTitle={geekiesTitle}
      geekiesComments={geekiesComments}
      geekCommentsButton={geekCommentsButton}
      geekCommentsButtonIcon={geekCommentsButtonIcon}
      formRef={formRef}
    />

    <FreePlatform
      freePlatformBadge={freePlatformBadge}
      freePlatformTitle={freePlatformTitle}
      freePlatformButton={freePlatformButton}
      freePlatformButtonIcon={freePlatformButtonIcon}
      formRef={formRef}
    />

    <Footer />
  </>
);

export default CreateFreeProfile;
